$(function () {
  var slider = $('.tc-function-contents').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    speed: 0,
    cssEase: 'linear',
    responsive: [{
      breakpoint: 1101,
      settings: {
        // adaptiveHeight: true,
        autoplay: false,
        speed: 500,
        autoplaySpeed: 3000,
        dots: true,
        appendDots: $('.tc-function-dots'),
        dotsClass: 'tc-function-dots'
      }
    }]
  }).on('beforeChange', function (event, slick, current_slide_index, next_slide_index) {
    $('.tc-function-nav-list-item').removeClass('slick-current');
    $('.tc-function-nav-list-item:eq(' + next_slide_index + ')').addClass('slick-current');
  });
  $('.tc-function-nav-list-item').on('click', function () {
    var index = $('.tc-function-nav-list-item').index(this);
    slider.slick('slickGoTo', index);
  });

  $('[data-function]').on('click', function(){
    if ($(window).width() > 1101){
      var href= $(this).attr('href');
      var target = $(href == '#' || href == '' ? 'html' : href);
      var position = target.offset().top - $('header').height();
      $('html, body').animate({ scrollTop: position }, 500, 'easeInQuad');
      $(href).trigger('click');
      return false;
    } else {
      var positionSp =$('#FUNCTION').offset().top - $('header').height();
      $('html,body').animate({ scrollTop: positionSp }, 500, 'easeInQuad');
      var data = $(this).data('function');
      console.log(data);
      $(data).trigger('click');

      
      return false;
    }
  });
  
  $(function () {
    new WOW().init();
  });
  $(window).on('scroll', function () {
    parallax();
  });

  function parallax() {
    var scroll = $(window).scrollTop(); //スクロールの位置を取得 

    $('[data-scrollelement]').each(function () {
      var imgY = $(this).offset().top;
      var ratio = parseInt($(this).data('scrollelement'));
      var diff = parseInt((imgY - scroll - 80) * ratio / 100);
      $(this).css({
        'transform': 'translateY(' + diff + 'px)'
      });
    });
    $('[data-scrollimage]').each(function () {
      var imgY = $(this).offset().top;
      var ratio = parseInt($(this).data('scrollimage'));
      var diff = parseInt((imgY - scroll) * ratio / 100);
      $(this).css({
        'background-position': 'top ' + diff + 'px center'
      });
    });
  }
});
//# sourceMappingURL=tc.js.map
